const SHELL_LANGUAGES = [`sh`, `shell`, `bash`, `fish`, `zsh`];

const getshellCodeBlocks = el => el.querySelectorAll(SHELL_LANGUAGES.map(lang => `[data-lang="${lang}"]`));

export const enhancer = el => {
  // Replace dollar signs in shell code blocks with a highlighted and unselectable version
  [...getshellCodeBlocks(el)].forEach(block => {
    const lines = block.innerHTML.split(/\r?\n/).map(line => {
      return line.charAt(0) === `$`
        ? `<span class="shell-dollar">$</span>${line.substring(2)}`
        : line;
    });
    block.innerHTML = lines.join(`<br/>`);
  });
};
